export interface IRttrStore {
    realmUuid?: string;
    realmTs?: string;
    realmSig?: string;
    realmHomeUrl?: string;
}

export default {} as IRttrStore;
